import React, { useEffect, useState } from 'react'
import { supabase } from '../supabaseClient'

const BRAND_BLUE   = '#1e90ff'
const BRAND_ORANGE = '#e87c1e'
const DEMO_FEE_INR = 199
// All demos are free for now — keep in sync with DEMO_IS_FREE in
// api/razorpay.js, which is what actually decides.
const DEMO_IS_FREE = true
const CLASS_OPTIONS = ['Piano', 'Guitar', 'Vocals', 'Chess']

// Explicit country-code picker instead of asking the visitor to type it
// correctly inside a free-text phone field — the WhatsApp API needs the
// full international number, and toE164() in whatsappHelper.js only
// guesses "add 91" for a bare 10-digit number, which silently breaks for
// every country other than India (relevant now that outside-India visitors
// get the free demo path). Every ITU-assigned country calling code — India
// pinned first since it's the overwhelming majority of leads, the rest
// alphabetical for easy scanning.
const COUNTRY_CODES = [
  { name: 'India', dial: '91' },
  { name: 'Afghanistan', dial: '93' },
  { name: 'Albania', dial: '355' },
  { name: 'Algeria', dial: '213' },
  { name: 'Andorra', dial: '376' },
  { name: 'Angola', dial: '244' },
  { name: 'Argentina', dial: '54' },
  { name: 'Armenia', dial: '374' },
  { name: 'Australia', dial: '61' },
  { name: 'Austria', dial: '43' },
  { name: 'Azerbaijan', dial: '994' },
  { name: 'Bahamas', dial: '1242' },
  { name: 'Bahrain', dial: '973' },
  { name: 'Bangladesh', dial: '880' },
  { name: 'Barbados', dial: '1246' },
  { name: 'Belarus', dial: '375' },
  { name: 'Belgium', dial: '32' },
  { name: 'Belize', dial: '501' },
  { name: 'Benin', dial: '229' },
  { name: 'Bhutan', dial: '975' },
  { name: 'Bolivia', dial: '591' },
  { name: 'Bosnia and Herzegovina', dial: '387' },
  { name: 'Botswana', dial: '267' },
  { name: 'Brazil', dial: '55' },
  { name: 'Brunei', dial: '673' },
  { name: 'Bulgaria', dial: '359' },
  { name: 'Burkina Faso', dial: '226' },
  { name: 'Burundi', dial: '257' },
  { name: 'Cambodia', dial: '855' },
  { name: 'Cameroon', dial: '237' },
  { name: 'Canada', dial: '1' },
  { name: 'Cape Verde', dial: '238' },
  { name: 'Central African Republic', dial: '236' },
  { name: 'Chad', dial: '235' },
  { name: 'Chile', dial: '56' },
  { name: 'China', dial: '86' },
  { name: 'Colombia', dial: '57' },
  { name: 'Comoros', dial: '269' },
  { name: 'Congo', dial: '242' },
  { name: 'Congo (DRC)', dial: '243' },
  { name: 'Costa Rica', dial: '506' },
  { name: 'Croatia', dial: '385' },
  { name: 'Cuba', dial: '53' },
  { name: 'Cyprus', dial: '357' },
  { name: 'Czech Republic', dial: '420' },
  { name: 'Denmark', dial: '45' },
  { name: 'Djibouti', dial: '253' },
  { name: 'Dominican Republic', dial: '1809' },
  { name: 'Ecuador', dial: '593' },
  { name: 'Egypt', dial: '20' },
  { name: 'El Salvador', dial: '503' },
  { name: 'Equatorial Guinea', dial: '240' },
  { name: 'Eritrea', dial: '291' },
  { name: 'Estonia', dial: '372' },
  { name: 'Eswatini', dial: '268' },
  { name: 'Ethiopia', dial: '251' },
  { name: 'Fiji', dial: '679' },
  { name: 'Finland', dial: '358' },
  { name: 'France', dial: '33' },
  { name: 'Gabon', dial: '241' },
  { name: 'Gambia', dial: '220' },
  { name: 'Georgia', dial: '995' },
  { name: 'Germany', dial: '49' },
  { name: 'Ghana', dial: '233' },
  { name: 'Greece', dial: '30' },
  { name: 'Grenada', dial: '1473' },
  { name: 'Guatemala', dial: '502' },
  { name: 'Guinea', dial: '224' },
  { name: 'Guinea-Bissau', dial: '245' },
  { name: 'Guyana', dial: '592' },
  { name: 'Haiti', dial: '509' },
  { name: 'Honduras', dial: '504' },
  { name: 'Hong Kong', dial: '852' },
  { name: 'Hungary', dial: '36' },
  { name: 'Iceland', dial: '354' },
  { name: 'Indonesia', dial: '62' },
  { name: 'Iran', dial: '98' },
  { name: 'Iraq', dial: '964' },
  { name: 'Ireland', dial: '353' },
  { name: 'Israel', dial: '972' },
  { name: 'Italy', dial: '39' },
  { name: 'Ivory Coast', dial: '225' },
  { name: 'Jamaica', dial: '1876' },
  { name: 'Japan', dial: '81' },
  { name: 'Jordan', dial: '962' },
  { name: 'Kazakhstan', dial: '7' },
  { name: 'Kenya', dial: '254' },
  { name: 'Kiribati', dial: '686' },
  { name: 'Kuwait', dial: '965' },
  { name: 'Kyrgyzstan', dial: '996' },
  { name: 'Laos', dial: '856' },
  { name: 'Latvia', dial: '371' },
  { name: 'Lebanon', dial: '961' },
  { name: 'Lesotho', dial: '266' },
  { name: 'Liberia', dial: '231' },
  { name: 'Libya', dial: '218' },
  { name: 'Liechtenstein', dial: '423' },
  { name: 'Lithuania', dial: '370' },
  { name: 'Luxembourg', dial: '352' },
  { name: 'Macau', dial: '853' },
  { name: 'Madagascar', dial: '261' },
  { name: 'Malawi', dial: '265' },
  { name: 'Malaysia', dial: '60' },
  { name: 'Maldives', dial: '960' },
  { name: 'Mali', dial: '223' },
  { name: 'Malta', dial: '356' },
  { name: 'Mauritania', dial: '222' },
  { name: 'Mauritius', dial: '230' },
  { name: 'Mexico', dial: '52' },
  { name: 'Moldova', dial: '373' },
  { name: 'Monaco', dial: '377' },
  { name: 'Mongolia', dial: '976' },
  { name: 'Montenegro', dial: '382' },
  { name: 'Morocco', dial: '212' },
  { name: 'Mozambique', dial: '258' },
  { name: 'Myanmar', dial: '95' },
  { name: 'Namibia', dial: '264' },
  { name: 'Nepal', dial: '977' },
  { name: 'Netherlands', dial: '31' },
  { name: 'New Zealand', dial: '64' },
  { name: 'Nicaragua', dial: '505' },
  { name: 'Niger', dial: '227' },
  { name: 'Nigeria', dial: '234' },
  { name: 'North Korea', dial: '850' },
  { name: 'North Macedonia', dial: '389' },
  { name: 'Norway', dial: '47' },
  { name: 'Oman', dial: '968' },
  { name: 'Pakistan', dial: '92' },
  { name: 'Palau', dial: '680' },
  { name: 'Palestine', dial: '970' },
  { name: 'Panama', dial: '507' },
  { name: 'Papua New Guinea', dial: '675' },
  { name: 'Paraguay', dial: '595' },
  { name: 'Peru', dial: '51' },
  { name: 'Philippines', dial: '63' },
  { name: 'Poland', dial: '48' },
  { name: 'Portugal', dial: '351' },
  { name: 'Qatar', dial: '974' },
  { name: 'Romania', dial: '40' },
  { name: 'Russia', dial: '7' },
  { name: 'Rwanda', dial: '250' },
  { name: 'Saudi Arabia', dial: '966' },
  { name: 'Senegal', dial: '221' },
  { name: 'Serbia', dial: '381' },
  { name: 'Seychelles', dial: '248' },
  { name: 'Sierra Leone', dial: '232' },
  { name: 'Singapore', dial: '65' },
  { name: 'Slovakia', dial: '421' },
  { name: 'Slovenia', dial: '386' },
  { name: 'Solomon Islands', dial: '677' },
  { name: 'Somalia', dial: '252' },
  { name: 'South Africa', dial: '27' },
  { name: 'South Korea', dial: '82' },
  { name: 'South Sudan', dial: '211' },
  { name: 'Spain', dial: '34' },
  { name: 'Sri Lanka', dial: '94' },
  { name: 'Sudan', dial: '249' },
  { name: 'Suriname', dial: '597' },
  { name: 'Sweden', dial: '46' },
  { name: 'Switzerland', dial: '41' },
  { name: 'Syria', dial: '963' },
  { name: 'Taiwan', dial: '886' },
  { name: 'Tajikistan', dial: '992' },
  { name: 'Tanzania', dial: '255' },
  { name: 'Thailand', dial: '66' },
  { name: 'Timor-Leste', dial: '670' },
  { name: 'Togo', dial: '228' },
  { name: 'Tonga', dial: '676' },
  { name: 'Trinidad and Tobago', dial: '1868' },
  { name: 'Tunisia', dial: '216' },
  { name: 'Turkey', dial: '90' },
  { name: 'Turkmenistan', dial: '993' },
  { name: 'Uganda', dial: '256' },
  { name: 'Ukraine', dial: '380' },
  { name: 'United Arab Emirates', dial: '971' },
  { name: 'United Kingdom', dial: '44' },
  { name: 'United States', dial: '1' },
  { name: 'Uruguay', dial: '598' },
  { name: 'Uzbekistan', dial: '998' },
  { name: 'Vanuatu', dial: '678' },
  { name: 'Vatican City', dial: '379' },
  { name: 'Venezuela', dial: '58' },
  { name: 'Vietnam', dial: '84' },
  { name: 'Yemen', dial: '967' },
  { name: 'Zambia', dial: '260' },
  { name: 'Zimbabwe', dial: '263' },
]

// Meta Ads pixel — hardcoded for now (2026-08-30) so it works without any
// Vercel env var setup. REACT_APP_META_PIXEL_ID still overrides this if
// ever set, e.g. to switch pixels later without a code change.
const META_PIXEL_ID = process.env.REACT_APP_META_PIXEL_ID || '2121255318782691'
// TEMPORARY (2026-08-30) — Meta Events Manager's Test Events code, so
// events show up live in the Test Events tab for verification before
// real ad traffic. Set back to null once confirmed working there;
// events tagged with this stop counting toward normal ad reporting
// while it's set.
const META_TEST_EVENT_CODE = null

// Meta's standard base code, verbatim (the exact snippet Events Manager
// hands you) — defines window.fbq and async-loads fbevents.js. Safe to
// call more than once; it no-ops if fbq already exists (e.g. React
// StrictMode's double-invoke in dev, or a hot reload).
function loadPixel() {
  if (!META_PIXEL_ID || window.fbq) return
  /* eslint-disable */
  !function(f,b,e,v,n,t,s)
  {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
  n.callMethod.apply(n,arguments):n.queue.push(arguments)};
  if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
  n.queue=[];t=b.createElement(e);t.async=!0;
  t.src=v;s=b.getElementsByTagName(e)[0];
  s.parentNode.insertBefore(t,s)}(window, document,'script',
  'https://connect.facebook.net/en_US/fbevents.js');
  /* eslint-enable */
  window.fbq('init', META_PIXEL_ID)
  window.fbq('track', 'PageView', {}, META_TEST_EVENT_CODE ? { test_event_code: META_TEST_EVENT_CODE } : undefined)
}
// The <noscript><img .../></noscript> fallback Meta's snippet also
// includes is intentionally left out — it only matters when JS is
// disabled, and this whole page is a JS-rendered React app, so a visitor
// without JS can't see the form or book anything anyway; there's nothing
// to track. Adding it to public/index.html instead (the only way to make
// a truly no-JS fallback work) would fire it on every route in this SPA,
// including the actual LMS — breaking the "pixel only on /demo" scoping.

// Fire-and-forget — never throws, never blocks the booking flow if the
// pixel isn't configured or the script hasn't finished loading yet.
function trackPixel(event, params) {
  try {
    if (typeof window.fbq !== 'function') return
    window.fbq('track', event, params || {}, META_TEST_EVENT_CODE ? { test_event_code: META_TEST_EVENT_CODE } : undefined)
  } catch (_) {}
}

function getParam(name) {
  return new URLSearchParams(window.location.search).get(name)
}

// The India Instagram/Facebook ad links to /demo?offer=india199: those
// visitors pay ₹199 (in India) even while the page is free for everyone
// else, and are asked for their city. Matches PAID_OFFER in api/razorpay.js.
const PAID_OFFER = 'india199'

export default function DemoRegistration() {
  const [mode,     setMode]     = useState('form') // form | redirecting | verifying | success | failed
  const [fullName, setFullName] = useState('')
  const [email,    setEmail]    = useState('')
  const [dialCode, setDialCode] = useState('91')
  const [phone,    setPhone]    = useState('')
  // ?class=Vocals (from an ad) picks the class in advance.
  const [course,   setCourse]   = useState(() => CLASS_OPTIONS.find(c => c.toLowerCase() === (getParam('class') || '').toLowerCase()) || '')
  const [age,      setAge]      = useState('')
  const [city,     setCity]     = useState('')
  const [offer]                 = useState(() => getParam('offer') === PAID_OFFER ? PAID_OFFER : null)
  const charges = !DEMO_IS_FREE || !!offer
  const [err,      setErr]      = useState('')
  const [result,   setResult]   = useState(null)
  // Defaults to India/paid until the geo check resolves — matches the
  // server's own fail-safe default in api/razorpay.js, so the displayed
  // price never promises "free" and then charges (or vice versa).
  const [isIndia,  setIsIndia]  = useState(charges)

  useEffect(() => { loadPixel() }, [])

  // Visitors outside India get a free demo instead of the ₹199 fee — actual
  // enforcement happens server-side in api/razorpay.js regardless of what
  // this shows; this is purely so the price displayed before submitting
  // matches what'll actually happen.
  useEffect(() => {
    if (!charges) return
    fetch('/api/razorpay', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ action: 'geo' }),
    })
      .then(r => r.json())
      .then(j => setIsIndia(!j.country || j.country === 'IN'))
      .catch(() => {}) // stay on the safe India/paid default
  }, [charges])

  useEffect(() => {
    const rid = getParam('rid')
    const razorpay_payment_id = getParam('razorpay_payment_id')
    if (!rid || !razorpay_payment_id) return

    setMode('verifying')
    ;(async () => {
      try {
        const res = await fetch('/api/razorpay', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            action: 'verify',
            registrationId: rid,
            razorpay_payment_id,
            razorpay_payment_link_id:            getParam('razorpay_payment_link_id'),
            razorpay_payment_link_reference_id:  getParam('razorpay_payment_link_reference_id'),
            razorpay_payment_link_status:        getParam('razorpay_payment_link_status'),
            razorpay_signature:                  getParam('razorpay_signature'),
          }),
        })
        const json = await res.json()
        if (!res.ok) throw new Error(json.error || 'Payment verification failed')
        // Guard against double-counting — reloading/revisiting this same
        // success URL (?rid=&razorpay_payment_id=) would otherwise re-fire
        // Purchase every time, even though the server-side verify() call
        // itself is already idempotent.
        const firedKey = `fb_purchase_fired:${rid}`
        if (!sessionStorage.getItem(firedKey)) {
          trackPixel('Purchase', { value: DEMO_FEE_INR, currency: 'INR' })
          sessionStorage.setItem(firedKey, '1')
        }
        setResult(json)
        setMode('success')
      } catch (e) {
        setErr(e.message)
        setMode('failed')
      }
    })()
  }, [])

  async function submit(e) {
    e.preventDefault()
    setErr('')
    if (!fullName.trim() || !email.trim() || !phone.trim() || !course || !age || (offer && !city.trim())) { setErr('Please fill in all required fields.'); return }

    setMode('redirecting')
    try {
      // Full international number, built explicitly from the chosen
      // country code + local digits — not guessed from a free-text field,
      // so it reaches the WhatsApp API (and toE164() in whatsappHelper.js)
      // unambiguous regardless of which country the visitor picks.
      const fullPhone = `+${dialCode}${phone.trim().replace(/\D/g, '')}`

      // The id is generated here rather than read back with .select():
      // anonymous visitors may insert into demo_registrations but not read
      // it (RLS), and insert+select needs read access to the new row.
      const registrationId = crypto.randomUUID()
      const { error: insertErr } = await supabase.from('demo_registrations').insert({
        id:              registrationId,
        full_name:       fullName.trim(),
        email:           email.trim(),
        phone:           fullPhone,
        course_interest: course,
        age:             Number(age),
        ...(city.trim() ? { city: city.trim() } : {}),
      })
      if (insertErr) throw new Error(insertErr.message)
      trackPixel('Lead') // form submitted — fires for both the paid and free paths alike

      const res = await fetch('/api/razorpay', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          action: 'create-link',
          registrationId,
          offer,
          name: fullName.trim(),
          email: email.trim(),
          phone: fullPhone,
        }),
      })
      const json = await res.json()
      if (!res.ok) throw new Error(json.error || (charges ? 'Could not start payment' : 'Could not complete your booking'))

      if (json.free) {
        // Free booking — already confirmed server-side, no payment step,
        // so there's no separate confirmation page/event to fire Purchase
        // from later. CompleteRegistration is the standard Meta event for
        // "signed up, no money changed hands."
        trackPixel('CompleteRegistration')
        setResult(json)
        setMode('success')
      } else {
        window.location.href = json.url
      }
    } catch (e) {
      setErr(e.message)
      setMode('form')
    }
  }

  const page = {
    minHeight: '100dvh', background: '#f0f4f8', display: 'flex',
    alignItems: 'flex-start', justifyContent: 'center',
    padding: 'clamp(24px, 6vh, 60px) clamp(12px, 4vw, 24px)',
    fontFamily: "'DM Sans', Arial, sans-serif",
  }
  const card = {
    width: '100%', maxWidth: '440px', background: '#fff', borderRadius: '20px',
    boxShadow: '0 8px 40px rgba(0,0,0,0.08)', overflow: 'hidden',
  }
  const header = {
    background: 'linear-gradient(135deg,#0a1622,#0d1f33)',
    padding: 'clamp(22px, 6vw, 32px) clamp(16px, 5vw, 28px)', textAlign: 'center',
  }
  const body = { padding: 'clamp(18px, 5vw, 28px)' }
  const lbl = {
    display: 'block', fontSize: '11px', fontWeight: 700, color: '#64748b',
    letterSpacing: '0.06em', textTransform: 'uppercase', marginBottom: '6px', marginTop: '16px',
  }
  const inp = {
    width: '100%', background: '#f8fafc', border: '1.5px solid #e2e8f0', borderRadius: '10px',
    padding: '12px 14px', fontSize: '16px', color: '#0f172a', outline: 'none',
    fontFamily: 'inherit', boxSizing: 'border-box',
  }

  return (
    <div style={page}>
      <div style={card}>
        <div style={header}>
          <div style={{ fontFamily: "'Arial Black',sans-serif", fontWeight: 900, fontSize: '26px', letterSpacing: '-0.02em' }}>
            <span style={{ color: BRAND_BLUE }}>UNI</span><span style={{ color: BRAND_ORANGE }}>EDD</span>
          </div>
          <div style={{ color: 'rgba(255,255,255,0.5)', fontSize: '11px', letterSpacing: '0.12em', textTransform: 'uppercase', marginTop: '4px' }}>Music &amp; Arts Academy</div>
        </div>

        <div style={body}>
          {mode === 'verifying' && (
            <div style={{ textAlign: 'center', padding: '2rem 0' }}>
              <div style={{ fontSize: '36px', marginBottom: '12px' }}>⏳</div>
              <div style={{ fontSize: '15px', fontWeight: 700, color: '#0f172a' }}>Confirming your payment...</div>
              <div style={{ fontSize: '13px', color: '#64748b', marginTop: '6px' }}>Please don't close this page.</div>
            </div>
          )}

          {mode === 'success' && (
            <div style={{ textAlign: 'center', padding: '1rem 0' }}>
              <div style={{ fontSize: '48px', marginBottom: '12px' }}>🎉</div>
              <div style={{ fontSize: '18px', fontWeight: 800, color: '#16a34a' }}>{result?.free ? 'Demo booked!' : 'Payment received!'}</div>
              <div style={{ fontSize: '14px', color: '#475569', marginTop: '10px', lineHeight: 1.6 }}>
                Thanks{result?.name ? `, ${result.name.split(' ')[0]}` : ''}! {result?.free
                  ? 'Your free demo class booking is confirmed. Our team will contact you shortly to confirm your demo date and time.'
                  : 'Thank you for registering for a demo class at UniEDD. Our team will confirm your demo time with you on WhatsApp, based on our teacher\'s availability.'}
                {' '}Check your email for confirmation.
              </div>
            </div>
          )}

          {mode === 'failed' && (
            <div style={{ textAlign: 'center', padding: '1rem 0' }}>
              <div style={{ fontSize: '48px', marginBottom: '12px' }}>⚠️</div>
              <div style={{ fontSize: '16px', fontWeight: 800, color: '#dc2626' }}>We couldn't confirm your payment</div>
              <div style={{ fontSize: '13px', color: '#64748b', marginTop: '8px', lineHeight: 1.6 }}>{err || 'If money was deducted, it will be refunded automatically. Please try again or contact support.'}</div>
              <button onClick={() => { window.location.href = '/demo' }} style={{ marginTop: '18px', padding: '11px 24px', background: BRAND_BLUE, color: '#fff', border: 'none', borderRadius: '10px', fontWeight: 700, fontSize: '14px', cursor: 'pointer', fontFamily: 'inherit' }}>Try Again</button>
            </div>
          )}

          {(mode === 'form' || mode === 'redirecting') && (
            <>
              <div style={{ fontSize: '19px', fontWeight: 800, color: '#0f172a', textAlign: 'center' }}>Book Your Demo Class</div>
              <div style={{ fontSize: '13px', color: '#64748b', textAlign: 'center', marginTop: '4px', lineHeight: 1.5 }}>
                {isIndia
                  ? <>A live 1:1 class with a UniEDD teacher. Reserve your spot for just <strong style={{ color: BRAND_ORANGE }}>₹{DEMO_FEE_INR}</strong>.</>
                  : <>Book your <strong style={{ color: BRAND_ORANGE }}>free</strong> demo class.</>}
              </div>

              <form onSubmit={submit}>
                <label style={lbl}>Full Name *</label>
                <input style={inp} type="text" value={fullName} onChange={e=>setFullName(e.target.value)} placeholder="Your name" required />

                <label style={lbl}>WhatsApp Number *</label>
                <div style={{ display: 'flex', gap: '8px' }}>
                  <select
                    value={dialCode}
                    onChange={e=>setDialCode(e.target.value)}
                    style={{ ...inp, colorScheme: 'light', flex: '0 0 110px', paddingRight: '4px' }}
                  >
                    {COUNTRY_CODES.map(c => (
                      <option key={c.name} value={c.dial}>+{c.dial} {c.name}</option>
                    ))}
                  </select>
                  <input
                    style={{ ...inp, flex: 1 }}
                    type="tel"
                    value={phone}
                    onChange={e=>setPhone(e.target.value)}
                    placeholder="98765 43210"
                    required
                  />
                </div>

                <label style={lbl}>Class *</label>
                <select style={{ ...inp, colorScheme: 'light' }} value={course} onChange={e=>setCourse(e.target.value)} required>
                  <option value="">Select a class</option>
                  {CLASS_OPTIONS.map(c => <option key={c} value={c}>{c}</option>)}
                </select>

                <label style={lbl}>Age *</label>
                <input style={inp} type="number" min="3" max="100" value={age} onChange={e=>setAge(e.target.value)} placeholder="Your age" required />

                {offer && (
                  <>
                    <label style={lbl}>City *</label>
                    <input style={inp} type="text" value={city} onChange={e=>setCity(e.target.value)} placeholder="e.g. Pune" autoComplete="address-level2" required />
                  </>
                )}

                <label style={lbl}>Email *</label>
                <input style={inp} type="email" value={email} onChange={e=>setEmail(e.target.value)} placeholder="you@example.com" required />

                {err && <div style={{ marginTop: '14px', padding: '10px 14px', background: '#fef2f2', border: '1px solid #fecaca', borderRadius: '9px', fontSize: '13px', color: '#dc2626' }}>{err}</div>}

                <button type="submit" disabled={mode==='redirecting'} style={{ width: '100%', marginTop: '20px', padding: '14px', background: mode==='redirecting' ? '#94a3b8' : `linear-gradient(135deg,${BRAND_BLUE},#0ea5e9)`, color: '#fff', border: 'none', borderRadius: '10px', fontWeight: 800, fontSize: '15px', cursor: mode==='redirecting' ? 'not-allowed' : 'pointer', fontFamily: 'inherit' }}>
                  {mode === 'redirecting'
                    ? (isIndia ? 'Redirecting to payment...' : 'Booking...')
                    : (isIndia ? `Pay ₹${DEMO_FEE_INR} & Book Demo →` : 'Book Free Demo →')}
                </button>
                {isIndia && <div style={{ textAlign: 'center', fontSize: '11px', color: '#94a3b8', marginTop: '10px' }}>🔒 Secure payment via Razorpay</div>}
              </form>
            </>
          )}
        </div>
      </div>
    </div>
  )
}
